const NOTHING_INVOICED = 'notInvoiced';
const PARTIALLY_INVOICED = 'partiallyInvoiced';
const FULLY_INVOICED = 'fullyInvoiced';
const BILLING_STATUS = [NOTHING_INVOICED, PARTIALLY_INVOICED, FULLY_INVOICED];

module.exports = {
    BILLING_STATUS,
    NOTHING_INVOICED,
    PARTIALLY_INVOICED,
    FULLY_INVOICED,
};
